import { render, staticRenderFns } from "./editProxy.vue?vue&type=template&id=51fe5d72&lang=pug&"
import script from "./editProxy.vue?vue&type=script&lang=js&"
export * from "./editProxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports